// You can write more code here

/* START OF COMPILED CODE */

import BaseButton from "../BaseButton";
import UIButton from "../components/UIButton";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class BtnBack extends BaseButton {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 60.5, y ?? 60.5);

    // btn_png
    const btn_png = scene.add.image(0, 0, "common", "btn.png");
    this.add(btn_png);

    // icon_back_arrow_png
    const icon_back_arrow_png = scene.add.image(0, 0, "common", "icon-back.png");
    this.add(icon_back_arrow_png);

    // this (components)
    new UIButton(this);

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
